import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    // Just use already written code on coffeescript
    App.helpers.edit_camera_listeners();
  }
}
